<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">new_releases</v-icon>
          <span class="headline ml-2 white--text">My tasks</span>
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-data-table
              v-if="transformedItems"
              :headers="headers"
              :items="transformedItems"
              class="elevation-0 row-pointer"
              :hide-default-footer="true"
              show-select
              v-model="selected"
            >
              <template v-slot:item.done="{ item }">
                <span v-if="item.done" class="success--text">Done</span>
                <span v-else class="theme-text">Pending</span>
              </template>

              <template v-slot:top>
                <div class="text-right">
                  <v-btn
                    class="action rounded-sm white--text"
                    @click="completeTasks"
                    :disabled="selected.length === 0"
                    depressed
                    >Mark as complete</v-btn
                  >
                </div>
              </template>
              <template v-slot:footer>
                <div class="text-center mt-5">
                  <v-btn
                    fab
                    small
                    color="theme white--text"
                    depressed
                    @click="previous"
                    :disabled="pagination.page <= 0"
                  >
                    <v-icon small>navigate_before</v-icon>
                  </v-btn>
                  <span>
                    <v-btn text :disabled="true">{{
                      pagination.page + 1
                    }}</v-btn>
                  </span>
                  <v-btn
                    fab
                    small
                    depressed
                    color="theme white--text"
                    @click="next"
                    :disabled="pagination.disableNext"
                  >
                    <v-icon small>navigate_next</v-icon>
                  </v-btn>
                </div>
                <!-- </td> -->
              </template>
            </v-data-table>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";

export default {
  name: Component.Protected.Employee.MyTasks,
  computed: {
    ...mapGetters(["userInfo"]),
    transformedItems() {
      return this.tasks.map((x) => ({ ...x, isSelectable: x.done === false }));
    },
  },
  methods: {
    completeTasks() {
      const details = [];
      this.selected.forEach((element) => {
        details.push({
          workflow_id: element.workflow_id,
          for_id: element.for,
          type: element.type,
          workflow_todo_id: element.workflow_todo_id,
          for_name: element.for_name,
        });
      });
      const data = {
        tasks: this.selected.map((x) => x.id),
        details: details,
      };

      if (this.selected.length > 0) {
        this.$store
          .dispatch(Actions.Tasks.Complete, data)
          .then((r) => {
            if (r.status === 200) {
              this.selected = [];
            }
          })
          .finally(() => {
            this.getTasks();
          });
      }
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.tasks.length <= this.search.limit) {
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTasks();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTasks();
      }
    },
    getTasks() {
      this.search.to = this.userInfo.userID;
      this.$store.dispatch(Actions.Tasks.Find, this.search).then((r) => {
        if (r.status === 200) {
          let len = r.data.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
          this.tasks = r.data;
        }
      });
    },
    setup() {
      this.getTasks();
    },
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Employee.MyTasks,
    tasks: [],
    selected: [],
    headers: [
      { text: "Name", value: "name" },
      // {text: 'Description', value: 'description'},
      { text: "For", value: "for_name" },
      { text: "Type", value: "type" },
      { text: "Status", value: "done" },
      { text: "Assigned on", value: "assigned_date" },
    ],
    search: { limit: 10, offset: 0, to: 0 },
    pagination: { disableNext: true, page: 0 },
  }),
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>

<style scoped>
</style>